import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, LogIn } from "lucide-react";
import { api, formatApiError } from "../api";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-login", { email, password });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center px-4 carbon-texture">
      <div className="w-full max-w-md rounded-2xl backdrop-blur-xl bg-slate-900/80 border border-amber-400/20 shadow-2xl p-8 animate-fade-up">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-amber-400/10 border border-amber-400/40 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5 text-amber-300" />
          </span>
          <h1 className="text-2xl font-bold text-white">Admin Girişi</h1>
        </div>
        <p className="mt-2 text-sm text-slate-400">Bu alan yalnızca yönetici yetkisine sahip hesaplar içindir.</p>

        <form onSubmit={submit} className="mt-7 space-y-5">
          <div>
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">E-posta</label>
            <input data-testid="admin-login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 focus:outline-none focus:border-amber-400/60 transition-colors"
              placeholder="admin@eposta.com" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Şifre</label>
            <input data-testid="admin-login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 rounded-xl bg-slate-950/70 border border-white/10 text-slate-100 focus:outline-none focus:border-amber-400/60 transition-colors"
              placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="admin-login-submit-button" type="submit" disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl bg-amber-400 text-slate-950 font-bold hover:bg-amber-300 active:scale-[0.99] transition-all disabled:opacity-50">
            <LogIn className="w-4 h-4" /> {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>

        <p className="mt-6 text-sm text-slate-400 text-center">
          Yönetici değil misiniz?{" "}
          <Link data-testid="admin-login-user-link" to="/giris" className="text-cyan-300 hover:text-cyan-200 font-semibold">
            Kullanıcı Girişi
          </Link>
        </p>
      </div>
    </div>
  );
}
